var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeIllustration = function SvgHomeIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 163,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home-illustration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.802 97.49c-.266-.93-.532-1.993-.532-3.056.266-1.86 1.596-3.323 3.058-4.386 1.462-1.063 3.057-1.993 4.254-3.322 3.323-3.721 2.392-9.569 4.12-14.22.798 3.19 1.463 6.379 1.463 9.568 0 3.19-.665 6.512-2.526 9.303-2.393 3.588-5.317 6.246-7.045 10.233-1.728-.664-2.26-2.525-2.792-4.12ZM21.769 101.078c-2.659-1.462-5.716-1.594-8.64-1.063-2.925.532-5.717 1.728-8.375 2.924 2.791.133 5.583.399 7.976 1.728 2.127 1.196 3.589 3.056 5.45 4.518 2.392 1.728 12.096 4.518 13.957.532 1.197-2.393-8.241-7.576-10.368-8.639ZM39.98 99.882c1.197-2.923 3.722-5.182 5.982-7.309a67.27 67.27 0 0 0-.399 14.619c.133 1.86.399 3.721-.133 5.449-1.728 5.98-4.652 1.328-5.583-1.861-.93-3.588-1.33-7.442.133-10.898ZM31.605 114.634c-1.595.133-3.057.664-4.652 1.329-3.323 1.329-6.646 2.658-9.837 4.12 4.121.266 8.242 0 12.23-.931.93-.265 1.994-.398 2.924-.265 1.861.265 3.19 1.86 4.52 3.189 2.924 2.525 10.368 2.126 6.646-2.525-2.127-2.791-8.507-5.183-11.83-4.917ZM16.584 91.776c-1.728-1.728-3.323-3.589-4.12-5.848-.931-2.26-1.064-4.784-.134-6.91.4 2.126.798 4.385 2.393 5.847 1.063 1.063 2.526 1.595 3.988 2.26 3.722 1.86 7.843 5.847 8.374 10.232-3.722.133-7.975-3.19-10.501-5.581ZM25.224 75.43c.4-2.127 1.462-3.987 2.526-5.98.665-1.197 1.462-2.526 2.791-3.057-.265 2.923-.531 5.847-.93 8.904-.133 1.86-.399 3.72-.133 5.714.266 2.26.532 9.17-3.323 5.05-1.728-2.126-1.33-8.24-.93-10.632ZM15.388 73.303c-.532-2.658-.532-5.448-1.728-7.974-1.728-3.853-5.849-6.113-9.837-7.575-1.196-.531-2.791-1.063-3.323-2.392 3.19.532 6.513 1.063 9.57 2.26 3.058 1.196 5.983 3.056 7.71 5.847 2.26 3.455 3.324 9.303 2.526 13.422-1.196 5.98-4.253-.265-4.918-3.588Z",
    fill: "#058293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.718 68.785a79.611 79.611 0 0 1 1.994 7.575c.398 1.86.797 3.854 1.595 5.581 1.063 2.525 2.791 4.652 4.52 6.91 3.588 4.918 6.779 10.234 9.038 15.948.931 1.994 1.596 4.12 2.925 5.981 2.659 4.12 7.045 6.645 9.837 10.631 2.26 3.323 3.456 7.31 3.722 11.297.133 2.657 0 5.315.399 7.973.398 2.658 1.329 5.316 3.19 7.177",
    stroke: "#00B0AC",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.219 75.297c-1.595 4.917-.133 10.366-1.064 15.549M39.98 90.048c-.798.798-1.862 1.196-2.526 1.994-.4.531-.532 1.063-.798 1.594-.532 1.595-1.196 3.323-1.196 5.05 0 1.197.133 2.526.133 3.722 0 1.196-.266 2.658-1.064 3.455M42.639 117.159c.398-2.126.398-4.385 0-6.645-.532-2.658-1.596-5.316-1.463-7.973 0-.798.266-1.728.798-2.393M17.78 103.869c2.659 2.392 6.115 3.455 9.571 4.253 1.197.266 2.26.531 3.456.531.798 0 1.463-.265 2.26-.133.93 0 1.861.399 2.526.931M35.194 117.425c2.127.266 4.254.93 5.982 2.259.93.665 1.861 1.595 2.924 2.126.4.266.798.399 1.197.399s.93-.133 1.063-.532M17.515 89.517a76.985 76.985 0 0 1 7.31 5.714c.665.665 1.33 1.33 2.128 1.728.797.398 1.86.531 2.658 0",
    stroke: "#00B0AC",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8 123.272c.531-.398 1.063-.93 1.329-1.462.532-1.063.266-2.392-.133-3.455-.399-1.063-.93-2.259-1.196-3.322-.532-3.19 2.127-6.114 2.791-9.303-1.595 1.462-3.057 2.924-4.253 4.784a10.604 10.604 0 0 0-1.861 5.981c.132 2.923.797 5.315.265 8.106 1.197.266 2.127-.531 3.058-1.329ZM169.585 129.252c1.994.133 3.722 1.196 5.184 2.525 1.463 1.329 2.526 2.924 3.589 4.652-1.595-.931-3.19-1.728-5.051-1.861-1.595-.133-3.057.399-4.652.532-1.861.133-8.242-1.728-7.843-4.652.133-1.86 7.178-1.329 8.773-1.196ZM160.015 122.076c.399-1.993-.266-4.12-.797-6.113a40.338 40.338 0 0 1-5.052 8.239c-.664.931-1.462 1.861-1.861 3.057-1.196 3.987 2.127 2.392 3.722.93 1.861-1.594 3.456-3.588 3.988-6.113ZM159.35 133.239c.798.665 1.462 1.462 2.127 2.392 1.329 1.861 2.658 3.854 3.988 5.715-2.393-1.329-4.52-2.924-6.514-4.784-.399-.399-.93-.931-1.462-1.196-1.063-.532-2.393 0-3.589.133-2.526.398-6.513-2.526-2.791-3.722 2.126-.797 6.513.133 8.241 1.462ZM175.7 125.93c1.595-.266 3.058-.797 4.387-1.727 1.329-.931 2.26-2.26 2.525-3.854-.93 1.063-1.993 2.126-3.456 2.392-.93.266-1.994 0-3.057-.133-2.659-.266-6.381.531-8.242 2.658 2.127 1.329 5.716 1.063 7.843.664ZM176.764 113.837c.532-1.329.665-2.791.665-4.12 0-.93.133-1.993-.399-2.658-.931 1.728-1.728 3.455-2.659 5.183-.531 1.063-1.196 2.259-1.861 3.19-.93 1.196-3.589 4.917 0 3.986 1.595-.531 3.589-4.119 4.254-5.581ZM182.878 116.096c1.196-1.329 2.26-2.791 3.722-3.854 2.393-1.462 5.45-1.329 8.109-.665.93.266 1.994.399 2.791-.133-1.994-.797-3.988-1.727-6.114-2.126-2.127-.399-4.387-.399-6.381.532-2.526 1.063-5.051 3.986-6.115 6.511-1.462 3.854 2.526 1.329 3.988-.265Z",
    fill: "#058293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.809 113.172c-1.329 1.064-2.526 2.26-3.855 3.456-.931.93-1.861 1.86-2.924 2.525-1.463 1.063-3.191 1.594-4.919 2.259-3.722 1.462-7.311 3.322-10.634 5.582-1.196.797-2.393 1.727-3.722 2.259-2.924 1.329-6.248 1.196-9.172 2.392-2.393.93-4.52 2.791-5.982 4.917-1.063 1.462-1.994 2.924-3.057 4.253-1.197 1.329-2.526 2.525-4.254 2.791",
    stroke: "#00B0AC",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.701 113.039c-.931 3.322-3.589 5.847-4.919 8.904M163.471 116.627c.133.665.531 1.329.664 1.994 0 .399 0 .797-.133 1.196-.265 1.063-.531 2.259-1.063 3.189-.399.665-.93 1.329-1.462 1.994-.399.664-.798 1.462-.665 2.392M152.305 130.714a13.273 13.273 0 0 1 2.259-3.721c1.197-1.329 2.792-2.392 3.59-3.854.265-.531.531-1.063.398-1.595M170.782 132.176c-2.26.399-4.653-.265-6.78-1.063-.664-.266-1.462-.531-2.126-.93-.399-.266-.798-.665-1.197-.93a4.088 4.088 0 0 0-1.728-.399M156.426 133.505c-1.197-.664-2.659-.93-4.121-.797-.798 0-1.595.266-2.393.133-.266 0-.532-.133-.797-.266a.731.731 0 0 1-.399-.664M175.966 124.336c-1.994 0-4.121.265-6.114.664-.532.133-1.197.266-1.861.133-.665-.133-1.197-.399-1.463-.93",
    stroke: "#00B0AC",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.022 47.123h53.039c3.589 0 6.38-2.924 6.38-6.38V7.255c0-3.588-2.924-6.379-6.38-6.379H26.022c-3.589 0-6.38 2.924-6.38 6.379v33.357c0 3.588 2.924 6.512 6.38 6.512Z",
    fill: "#FFC40A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.968 44.465s-6.38 3.322-7.311 8.638c-.266 1.196-1.861 1.728-2.659.797-2.127-2.126-4.652-6.378-4.652-14.22",
    fill: "#FFC40A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.252 28.118a4.12 4.12 0 1 0 0-8.24 4.12 4.12 0 0 0 0 8.24ZM52.608 28.118a4.12 4.12 0 1 0 .001-8.24 4.12 4.12 0 0 0 0 8.24ZM66.965 28.118a4.12 4.12 0 1 0 0-8.24 4.12 4.12 0 0 0 0 8.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.726 141.346c-10.634-.399-21.268 3.854-28.18 10.631-3.457 3.456-.798 8.771 4.52 9.17 48.917 2.791 97.834 1.462 146.752.93 38.948-.531 28.447-9.701 21.933-14.087-8.507-5.847-11.697-5.714-19.274-7.043-34.695-5.582-70.452-6.778-105.679-3.455",
    fill: "#E5EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.601 76.094H31.606v3.19H142.6v-3.19ZM114.819 38.352 64.04 76.094H31.605l50.38-37.742h32.834Z",
    fill: "#024390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.819 38.352v3.19L64.04 79.283v-3.19l50.779-37.742Z",
    fill: "#012A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.432 41.541h-28.18v20.998l-16.35 12.093v75.884h89.194V74.632l-44.664-33.091Z",
    fill: "#0454A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25 41.541 37.588 74.632v75.884h89.195V74.632L82.251 41.541Z",
    fill: "#0384D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.347 100.148H70.154v50.367h24.193v-50.367Z",
    fill: "#0454A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.096 77.024 115.084 46.99h2.792l-7.444-5.449H82.251v5.449l50.779 37.742h22.066v-7.708Z",
    fill: "#024390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.251 41.541 50.779 37.742h32.434l-50.38-37.742H82.251Z",
    fill: "#024390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.251 38.352 50.779 37.742h32.434l-50.38-37.742H82.251Z",
    fill: "#0454A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.251 38.352v3.19l50.779 37.742v-3.19L82.251 38.352ZM165.465 76.094H133.03v3.19h32.435v-3.19Z",
    fill: "#012A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.587 74.632v5.582L82.25 46.99l44.531 33.224v-5.582L82.251 41.541 37.587 74.632Z",
    fill: "#0075C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.465 77.689H133.03",
    stroke: "#0454A2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.483 102.806h-9.704v21.13h9.704v-21.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.598 100.148h-6.115v23.788h6.115v-23.788ZM105.78 100.148h-6.115v23.788h6.115v-23.788Z",
    fill: "#0454A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.402 101.61h-3.988v9.701h3.988v-9.701ZM104.716 101.61h-3.987v9.701h3.987v-9.701ZM120.402 112.773h-3.988v9.701h3.988v-9.701ZM104.716 112.773h-3.987v9.701h3.987v-9.701Z",
    stroke: "#024390",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.779 115.564v-15.283h6.78v8.638c-.133 3.588-3.058 6.645-6.78 6.645Z",
    fill: "#0075C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.483 115.564v-15.283h-6.779v8.638c0 3.588 3.057 6.645 6.779 6.645Z",
    fill: "#0075C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.189 102.806h-9.704v21.13h9.704v-21.13Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.304 100.148h-6.115v23.788h6.115v-23.788ZM136.486 100.148h-6.115v23.788h6.115v-23.788Z",
    fill: "#024390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.108 101.61h-3.988v9.701h3.988v-9.701ZM135.422 101.61h-3.987v9.701h3.987v-9.701ZM151.108 112.773h-3.988v9.701h3.988v-9.701ZM135.422 112.773h-3.987v9.701h3.987v-9.701Z",
    stroke: "#012A66",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.485 115.564v-15.283h6.78v8.638c0 3.588-3.058 6.645-6.78 6.645Z",
    fill: "#0062B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19 115.564v-15.283h-6.78v8.638c0 3.588 3.058 6.645 6.78 6.645Z",
    fill: "#0062B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.855 101.61h-9.704v22.326h9.704V101.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.97 100.148h-6.114v23.788h6.114v-23.788ZM49.285 100.148H43.17v23.788h6.115v-23.788Z",
    fill: "#0454A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.907 101.61h-3.988v9.701h3.988v-9.701ZM48.221 101.61h-3.988v9.701h3.988v-9.701ZM63.907 112.773h-3.988v9.701h3.988v-9.701ZM48.221 112.773h-3.988v9.701h3.988v-9.701Z",
    stroke: "#024390",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.151 115.564v-15.283h6.78v8.638c0 3.588-3.058 6.645-6.78 6.645Z",
    fill: "#0075C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.855 115.564v-15.283h-6.779v8.638c.133 3.588 3.057 6.645 6.78 6.645ZM94.347 90.314H70.154v5.582h24.193v-5.582Z",
    fill: "#0075C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.892 128.189a1.462 1.462 0 1 0 0-2.923 1.462 1.462 0 0 0 0 2.923Z",
    fill: "#FFC40A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.512 81.277h82.282",
    stroke: "#0075C8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.789 103.869h-7.577v17.675h7.577v-17.675ZM90.891 103.869h-7.577v17.675h7.577v-17.675Z",
    stroke: "#024390",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25 71.974a6.38 6.38 0 1 0 0-12.758 6.38 6.38 0 1 0 0 12.758Z",
    stroke: "#024390",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.06 148.256c-.531-4.518 2.26-8.771 5.583-11.827 3.324-3.057 7.444-5.183 10.635-8.373.93 7.309-1.463 14.884-6.248 20.466.133 0-5.051 6.512-9.97-.266Z",
    fill: "#56D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.111 149.851c-.93-5.05-4.253-9.967-9.438-13.821-.265 5.05 1.596 10.233 5.185 14.884l.93.798c.931.797 2.26.664 2.925-.266.398-.532.531-1.063.398-1.595Z",
    fill: "#058192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.766 148.256c.532-4.518-2.26-8.771-5.583-11.827-3.323-3.057-7.444-5.183-10.634-8.373-.93 7.309 1.462 14.884 6.247 20.466 0 0 5.184 6.512 9.97-.266Z",
    fill: "#56D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.715 149.851c.93-5.05 4.254-9.967 9.438-13.821.266 5.05-1.595 10.233-5.184 14.884l-.93.798c-.931.797-2.26.664-2.925-.266a3.54 3.54 0 0 1-.4-1.595Z",
    fill: "#058192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.267 142.01c2.127 1.329 3.589 3.456 4.254 5.715 1.196-1.861 3.19-3.19 5.317-3.588.133 0-1.595 4.385-1.861 4.784-.798 1.063-2.526 3.056-3.988 2.924-3.456 0-3.988-7.443-3.722-9.835ZM113.889 142.01c-2.127 1.329-3.589 3.456-4.254 5.715-1.196-1.861-3.19-3.19-5.317-3.588-.133 0 1.595 4.385 1.861 4.784.797 1.063 2.525 3.056 3.988 2.924 3.456 0 3.988-7.443 3.722-9.835Z",
    fill: "#56D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.793 96.294h-41.208c-2.791 0-4.918-2.26-4.918-4.917V65.329c0-2.79 2.26-4.917 4.918-4.917h41.208a4.907 4.907 0 0 1 4.919 4.917v25.915c0 2.79-2.127 5.05-4.919 5.05Z",
    fill: "#FFC40A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.836 94.3s5.051 2.659 5.716 6.778c.133.931 1.462 1.329 2.127.665 1.595-1.728 3.589-4.917 3.589-11.03",
    fill: "#FFC40A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.023 82.34a3.19 3.19 0 1 0 .001-6.38 3.19 3.19 0 0 0-.001 6.38ZM146.189 82.34a3.19 3.19 0 1 0 .001-6.38 3.19 3.19 0 0 0-.001 6.38ZM157.355 82.34a3.19 3.19 0 1 0 .001-6.38 3.19 3.19 0 0 0-.001 6.38Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-illustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .875)",
    d: "M0 0h197v162H0z"
  })))));
};
export default SvgHomeIllustration;